import React, { Component } from 'react'
import { TextField, InputAdornment } from '@material-ui/core'
import FingerprintOutlinedIcon from '@material-ui/icons/FingerprintOutlined'

export class IdNumber extends Component {
  render() {
    return (
      <TextField
        style={{
          margin: '6px'
        }}
        label="ID Number"
        name="buid"
        value={(this.props.buid && this.props.buid) || ''}
        type="number"
        variant="outlined"
        id="buid"
        margin="dense"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <FingerprintOutlinedIcon
                fontSize="small"
                className="icon-color"
              />
            </InputAdornment>
          )
        }}
        className="text-field-style"
        required
        autoFocus
        onChange={this.props.onChange}
      />
    )
  }
}
export default IdNumber
